module.exports = __webpack_public_path__ + "img/cg_icon.bad967ee.png";